export const DASHBOARD_ROUTES = {
  __ROOT__: '/dashboard',
}
